export default __webpack_public_path__ + "static/media/hungo-screenshot-05.d9cc2a49.png";